import Logos from '@serko/zui/es/Logos/Logos';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { OptionId, SegmentTypes } from '../../../../../../../models/itinerary';
import { AppState } from '../../../../../../../store/model';
import { getSegmentType, isSaviSelectIntl } from '../../../../../../../store/reducers/itinerary/selectors';
import { createGetProviders } from '../../../../../../../store/reducers/segment-options/selectors';
import { AirLogo } from './Logos/AirLogo';
import { CarLogo } from './Logos/CarLogo';
import { HotelLogo } from './Logos/HotelLogo';
import { getACarDetailsForSaviSelectIntl, getAHotelDetailsForSaviSelectIntl, getSegmentTypeForSaviSelectIntl } from '../../../../../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  segmentId: number;
  optionId: OptionId;
}

interface StateProps {
  type: SegmentTypes;
  providers: Array<{
    code: string;
    name: string;
  }>;
}

interface ProviderLogosProps extends OwnProps, StateProps {}

class ProviderLogosBase extends PureComponent<ProviderLogosProps> {
  public static displayName = 'ProviderLogos';

  private get Logo() {
    const { type } = this.props;

    switch (type) {
      case 'Car':
        return CarLogo;
      case 'Hotel':
        return HotelLogo;
      case 'Air':
      default:
        return AirLogo;
    }
  }

  public render() {
    const { providers } = this.props;
    const Logo = this.Logo;

    return (
      <Logos size="medium">
        {providers.map(({ name, code }) => (
          <Logo code={code} name={name} key={code} />
        ))}
      </Logos>
    );
  }
}

const mapStateToProps = (
  state: AppState,
  { segmentId, optionId }: OwnProps,
) => {
  if(!isSaviSelectIntl(state)) {
    return {
      type: getSegmentType(segmentId)(state),
      providers: createGetProviders(segmentId, optionId.toString())(state),
    };
  } else {
    const type = getSegmentTypeForSaviSelectIntl(segmentId)(state);
    let chainCode = '';
    let chainName = '';
    if(type === 'Hotel'){
      const hotel = getAHotelDetailsForSaviSelectIntl(segmentId, Number(optionId))(state);
      chainCode = hotel!.hotelChainCode;
      chainName = hotel!.hotelChainName;
    }
    else if(type === 'Car'){
      const car = getACarDetailsForSaviSelectIntl(segmentId, Number(optionId))(state);
      chainCode = car!.carChainCode;
      chainName = car!.carChainName;
    }

    return {
      type: type,
      providers: [{code: chainCode, name: chainName}],
    };
  }
};

const enhance = compose<ProviderLogosProps, OwnProps>(
  pure,
  connect(mapStateToProps),
);

export const ProviderLogos = enhance(ProviderLogosBase);
